import _Vue from 'vue';
import { stringifyUrl } from 'query-string';
import dayjs from 'dayjs';
import { getRequest, postRequest } from "./auth-service";
import { IS_PRODUCTION } from "@pazion/pazion-core/src/config";
import axios from "axios";
import { IProjectSettings } from "@pazion/pazion-core/src/models/config_variables";
import { authentication } from "@pazion/pazion-core/src/store";
import { IFieldDefinitions } from '../models/settings-model';
import {IEntityLog, ITenant} from "@pazion/pazion-core/src/models/models";

export async function getCountries(filter?: any, limit?: number) {
  filter = filter || {};
  if (filter) {
    const url = stringifyUrl({
      url: 'base/country',
      query: {
        filter: JSON.stringify(filter),
        limit: limit
      }
    });
    return (await getRequest(url)).data;

  }
  return (await getRequest('base/country')).data;
}

export const getTenantList = async (): Promise<ITenant[]> => {
  return (await getRequest("base/tenants")).data;
};


export async function getEntityLog(entityId: string | number, entityType: string): Promise<IEntityLog[]> {
  const url = stringifyUrl({
    url: 'base/entity-log',
    query: {
      entity: entityType,
      entityId: entityId,
    }
  });
  return <IEntityLog[]> (await getRequest(url)).data;
}

/**
 *
 * @param fileType the file type [#todo, ability to retrieve a list of valid types]
 * @param file the file to upload
 * @param indexed
 * @param separator
 */
export async function uploadFlowFileToQueue(fileType: string, file: File, indexed:boolean = true, separator: string = ';') {
  let formData = new FormData();
  formData.append('file', file);
  formData.append('type', fileType);
  formData.append('indexed', String(indexed));
  formData.append('column_separator', separator);


  return (await postRequest(`/import-flow-file`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })).data;
}

/**
 *  Format and validate string with date (iso8601) with format str and timezone
 @param value - date string, in format ISO8601 (2021-12-20T12:00:10)
 @param branchLocalTime
 @param format - string format
 @param notValidate
 @returns string with date
 */
export function formatDateTime(value: string, branchLocalTime: string, format: string, notValidate?: boolean): string {
  try {
    if (!value) return '';
    if (branchLocalTime) {
      //@ts-ignore
      const formattedDate = dayjs().tz(value, branchLocalTime).format(format);
      const validFormattedDate = !notValidate ? dayjs(formattedDate, format).isValid() : true;
      //@ts-ignore
      return validFormattedDate ? formattedDate : dayjs(value).tz(branchLocalTime).format(format);
    }
    return dayjs(value).format(format);
  }
  catch (e) {
    return '';
  }
}


/**
 * Get Project settings
 * @returns {config: {}, featuresFlags: {}}
 */
export async function getConfigSettings(): Promise<IProjectSettings> {
  if (IS_PRODUCTION && !('VUE_APP_BACKEND_API_ROOT' in process.env)) {
    if (authentication.getApiUrl == 'undefined' || authentication.getApiUrl.length == 0) {
      return (await axios.get('/api/v2/settings/frontend')).data;
    }
    return (await axios.get(authentication.getApiUrl + 'settings/frontend')).data;
  }
  return (await getRequest(process.env.VUE_APP_BACKEND_API_ROOT + 'settings/frontend')).data;
}

/**
 * 
 * @returns {
 *  ClassName: {
 *  "defaults": {
 *  "visible": true,
 *   "required": false
 *  },
 * "fields": {
 *  "fieldName": {
 *    "label": "label",
  *     "visible": true,
  *    "required": true
 *    } 
 * }
 * */
export async function getSettingsFieldsDefinition(): Promise<IFieldDefinitions> {
  if (IS_PRODUCTION && !('VUE_APP_BACKEND_API_ROOT' in process.env)) {
    if (authentication.getApiUrl == 'undefined' || authentication.getApiUrl.length == 0) {
      return (await axios.get('/api/v2/settings/field-definitions')).data;
    }
    return (await axios.get(authentication.getApiUrl + 'settings/field-definitions')).data;
  }
  return (await getRequest(process.env.VUE_APP_BACKEND_API_ROOT + 'settings/field-definitions')).data;
}

export const allowedDefaultRedirect = (instance: typeof _Vue) => {
  // @ts-ignore
  return !instance.$membersCardManagement || (instance.$membersCardManagement && window.location.pathname.includes("admin"));
}